module.exports = __webpack_public_path__ + "static/media/close-x.a4eeead6.svg";